// Module
var code = "<div data-bind=\"geWindow: $data, header: 'My Favorites', modalSize: 'lg', align: true\" style=\"background-color:rgba(0,0,0,.5)\"> <div id=\"my-favorites-model-component\"> <div class=\"panel-body\" id=\"divMyFavoritesPanel\"> <div id=\"myFavoritesGrid\"></div> </div> </div> </div> ";
// Exports
export default code;